import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/cppProgrammingLeftImg.png";
import rightimg from "../../../assets/cppProgrammingRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import cppProgrammingBenefitsImg1 from "../../../assets/cppProgrammingBenefitsImg1.png";
import cppProgrammingBenefitsImg2 from "../../../assets/cppProgrammingBenefitsImg2.png";
import cppProgrammingBenefitsImg3 from "../../../assets/cppProgrammingBenefitsImg3.png";
import cppProgrammingBenefitsImg4 from "../../../assets/cppProgrammingBenefitsImg4.png";
import cppProgrammingBenefitsImg5 from "../../../assets/cppProgrammingBenefitsImg5.png";
import cppProgrammingBenefitsImg6 from "../../../assets/cppProgrammingBenefitsImg6.png";
import cppProgrammingBenefitsImg7 from "../../../assets/cppProgrammingBenefitsImg7.png";
import cppProgrammingBenefitsImg8 from "../../../assets/cppProgrammingBenefitsImg8.png";
import cppProgrammingBenefitsImg9 from "../../../assets/cppProgrammingBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import cppProgrammingFunActivitiesImg1 from "../../../assets/cppProgrammingFunActivitiesImg1.png";
import cppProgrammingFunActivitiesImg2 from "../../../assets/cppProgrammingFunActivitiesImg2.png";
import cppProgrammingFunActivitiesImg3 from "../../../assets/cppProgrammingFunActivitiesImg3.png";
import cppProgrammingFunActivitiesImg4 from "../../../assets/cppProgrammingFunActivitiesImg4.png";
import cppProgrammingFunActivitiesImg5 from "../../../assets/cppProgrammingFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const CppProgrammingPortal = () => {
  const cppProgrammingpage = heroContent.cppProgrammingpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "5",
      description:
        "Fundamentals of C++ Students will learn C++ basics, including variables, data types, conditions, and operators, building a strong foundation in the language.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "5",
      description:
        "C++ Logics Students will explore loops, arrays, and functions, learning how to handle repetitive tasks, store large data, and create reusable code.",
    },
    {
      title: "Module 3",
      activities: "10",
      classes: "5",
      description:
        "Object-Oriented Programming- Students will learn about classes, objects, inheritance, polymorphism, encapsulation, and file handling to organize code and manage data effectively.",
    },
  ];

  const benefitsData = [
    {
      title: "Master Programming Basics",
      description: "Learn variables, data types, and operators in C++.",
      icon: cppProgrammingBenefitsImg1,
    },
    {
      title: "Enhance Problem-Solving",
      description: "Develop logical and creative thinking.",
      icon: cppProgrammingBenefitsImg2,
    },
    {
      title: "Create Object-Oriented Code",
      description: "Understand classes, objects, and inheritance.",
      icon: cppProgrammingBenefitsImg3,
    },
    {
      title: "Build Advanced Apps",
      description: "Work with functions, loops, and arrays.",
      icon: cppProgrammingBenefitsImg4,
    },
    {
      title: "Sharpen Math Skills",
      description: "Apply programming to solve mathematical problems.",
      icon: cppProgrammingBenefitsImg5,
    },
    {
      title: "Boost Creativity",
      description: "Express ideas through code and design.",
      icon: cppProgrammingBenefitsImg6,
    },
    {
      title: "Foster Persistence",
      description: "Overcome challenges with determination.",
      icon: cppProgrammingBenefitsImg7,
    },
    {
      title: "Advance Career Potential",
      description: "Unlock job opportunities in tech.",
      icon: cppProgrammingBenefitsImg8,
    },
    {
      title: "Develop Digital Literacy",
      description: "Gain essential tech skills for the future.",
      icon: cppProgrammingBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Bill Calculator",
      image: cppProgrammingFunActivitiesImg1,
    },
    {
      title: "Cricket Statistics",
      image: cppProgrammingFunActivitiesImg2,
    },
    {
      title: "Bank Transactions",
      image: cppProgrammingFunActivitiesImg3,
    },
    {
      title: "Grade Calculator",
      image: cppProgrammingFunActivitiesImg4,
    },
    {
      title: "File Handling",
      image: cppProgrammingFunActivitiesImg5,
    },
  ];

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={cppProgrammingpage.titlePart1}
        description={cppProgrammingpage.description}
        buttonText={cppProgrammingpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From C++ Programming"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn C++ Programming"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default CppProgrammingPortal;
